export default __webpack_public_path__ + "static/media/123456.f0ac944e.jpg";